import { render, staticRenderFns } from "./AddTransportationPlan.vue?vue&type=template&id=fa40e54a&scoped=true&"
import script from "./AddTransportationPlan.vue?vue&type=script&lang=js&"
export * from "./AddTransportationPlan.vue?vue&type=script&lang=js&"
import style0 from "./AddTransportationPlan.vue?vue&type=style&index=0&id=fa40e54a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa40e54a",
  null
  
)

export default component.exports